import { Skeleton } from '@/components/ui/skeleton';

/**
 * The feed's loading state: a day-header shimmer over four timeline rows.
 *
 * ⚠️ **Composed from the `Skeleton` atom rather than reusing `ListSkeleton`, deliberately.** `ListSkeleton`
 * renders two text bars per row and no leading tile, so swapping it for a feed row — which leads with a 24px
 * kind tile — jumps the layout at exactly the moment the content arrives. That is the failure the skeleton
 * helpers exist to prevent, so matching the real row's shape matters more than reusing the helper.
 *
 * The rail and the panel header stay live behind this; only the feed area is replaced.
 */
export function ActivityFeedSkeleton() {
  return (
    <div className="space-y-2 px-3 py-2" aria-hidden>
      <Skeleton className="h-3 w-24" />

      {Array.from({ length: 4 }, (_, i) => (
        <div key={i} className="flex gap-2.5 py-1.5">
          {/* `rounded-[7px]` mirrors the real tile (fidelity spec PART 3a) — a radius pop on content
              arrival is exactly the layout jump this skeleton exists to prevent. */}
          <Skeleton className="h-6 w-6 shrink-0 rounded-[7px]" />
          <div className="min-w-0 flex-1 space-y-1.5">
            {/* Staggered widths so four identical bars do not read as a table. */}
            <Skeleton className="h-3" style={{ width: `${72 - i * 8}%` }} />
            <Skeleton className="h-2.5 w-16" />
          </div>
        </div>
      ))}
    </div>
  );
}
